var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delete-button',_vm._b({on:{"click":_vm.deleteHandler}},'delete-button',Object.assign({}, _vm.$attrs, {loading: _vm.loading, label: _vm.label}),false))}
var staticRenderFns = []

export { render, staticRenderFns }